module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-list"
  }, [_c('ul', _vm._l((_vm.articleList), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "article-item"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          _vm.itemClick(item)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showCopyRight),
        expression: "showCopyRight"
      }],
      staticClass: "tag"
    }, [_vm._v("[" + _vm._s(item.copyright) + "]")]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item[_vm.articleTime]))])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-e92c0f14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/consultant/article-list.vue
// module id = 627
// module chunks = 1